import { useState } from "react";
import p1 from "../assets/p1.jpg";
import p3 from "../assets/p3.jpg";
import p5 from "../assets/p5.png";
import HeaderNavbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const profiles = [
  {
    id: 1,
    name: "Priya Patil",
    age: 26,
    religion: "Lingayat",
    caste: "Sadar",
    height: "5'4\"",
    education: "B.Tech (IT)",
    occupation: "Software Engineer",
    location: "Mumbai, Maharashtra",
    income: "8 LPA",
    maritalStatus: "Unmarried",
    photo: p1,
    online: true,
    verified: true,
    shortlisted: false,
  },
  {
    id: 2,
    name: "Anjali Hiremath",
    age: 24,
    religion: "Lingayat",
    caste: "Panchamasali",
    height: "5'1\"",
    education: "MBA",
    occupation: "Marketing Manager",
    location: "Delhi, NCR",
    income: "6 LPA",
    maritalStatus: "Unmarried",
    photo: p5,
    online: false,
    verified: true,
    shortlisted: true,
  },
  {
    id: 3,
    name: "Meera Desai",
    age: 28,
    religion: "Lingayat",
    caste: "Banajiga",
    height: "5'5\"",
    education: "MBBS",
    occupation: "Doctor",
    location: "Bangalore, Karnataka",
    income: "12 LPA",
    maritalStatus: "Unmarried",
    photo: p3,
    online: true,
    verified: false,
    shortlisted: false,
  },
];

export default function Profile() {
  const navigate = useNavigate();
  const [shortlisted, setShortlisted] = useState(
    profiles.reduce((acc, p) => ({ ...acc, [p.id]: p.shortlisted }), {})
  );

  return (
    <>
      <div className="profile-page">
        <HeaderNavbar />

        <div className="profile-container">
          <main className="profile-main">

            <div className="profile-count">
              Showing <strong>{profiles.length}</strong> profiles matching your preferences
            </div>

            {profiles.map((profile) => (
              <div key={profile.id} className="profile-card">


                <div className="profile-image">
                  <img src={profile.photo} alt={profile.name} />

                  {profile.online && (
                    <span className="badge online">● Online</span>
                  )}

                  {profile.verified && (
                    <span className="badge verified">✔ Verified</span>
                  )}
                </div>


                <div className="profile-details">

                  <div className="profile-header">
                    <div>
                      <h3>{profile.name}</h3>
                      <p>
                        {profile.age} yrs • {profile.height} • {profile.maritalStatus}
                      </p>
                    </div>

                    <span className="profile-id">
                      ID: M{1000 + profile.id}
                    </span>
                  </div>

                  <div className="profile-grid">
                    <div><span>Religion:</span> <b>{profile.religion}</b></div>
                    <div><span>Caste:</span> <b>{profile.caste}</b></div>
                    <div><span>Education:</span> <b>{profile.education}</b></div>
                    <div><span>Occupation:</span> <b>{profile.occupation}</b></div>
                    <div><span>Income:</span> <b>{profile.income}</b></div>
                    <div><span>Location:</span> <b>{profile.location}</b></div>
                  </div>

                  <div className="profile-actions">
                    <button className="profile-btn primary" onClick={() => navigate("/register")}>
                      💌 Send Interest
                    </button>

                    <button className="profile-btn outline" onClick={() => navigate("/register")}>
                      👁 View
                    </button>

                    <button
                      onClick={() =>
                        setShortlisted((s) => ({
                          ...s,
                          [profile.id]: !s[profile.id],
                        }))
                      }
                      className={`profile-btn shortlist ${shortlisted[profile.id] ? "active" : ""
                        }`}
                    >
                      {shortlisted[profile.id] ? "★ Shortlisted" : "☆ Shortlist"}
                    </button>

                    <button className="profile-btn chat" onClick={() => navigate("/register")}>
                      💬 Chat
                    </button>
                  </div>

                </div>
              </div>
            ))}
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
}